/**
 * Carries "I clicked Get Started on the Email Signatures landing page" across
 * to login/register, the same way qrEncode.js's pending-draft keys carry a QR
 * draft across - so registering doesn't dump someone on the generic account
 * landing page after they already told us what they came here for.
 *
 * Two readers, deliberately not merged into one:
 * - peekSignatureBuilderIntent: non-destructive check, used by
 *   Login/Register/VerifyEmail only to decide WHERE to send someone.
 * - takeSignatureBuilderIntent: reads and clears, used once the signature
 *   builder itself has landed.
 */
const PENDING_INTENT_KEY = 'signatureBuilderPendingIntent';

export function markSignatureBuilderIntent() {
  try { window.localStorage.setItem(PENDING_INTENT_KEY, '1'); } catch (e) { /* storage unavailable */ }
}

export function peekSignatureBuilderIntent() {
  try { return window.localStorage.getItem(PENDING_INTENT_KEY) === '1'; } catch (e) { return false; }
}

export function takeSignatureBuilderIntent() {
  const had = peekSignatureBuilderIntent();
  try { window.localStorage.removeItem(PENDING_INTENT_KEY); } catch (e) { /* ignore */ }
  return had;
}
